module.exports = __webpack_public_path__ + "static/media/programmes-gray-icon.88499267.svg";